<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品列表
  -->
    <div v-loading="loading" class="user">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="兑换中" name="has_audit"></el-tab-pane>
            <el-tab-pane label="待审核" name="wait_audit"></el-tab-pane>
        </el-tabs>
        <div class="common-level-rail">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="openGoods()">商品报名</el-button>
        </div>
        <div class="goods-content point-list">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%">
                    <el-table-column prop="goods_name" label="商品名称" width="360">
                        <template slot-scope="scope">
                            <div class="goods-info">
                                <div class="pic" style="width: 40px; height: 40px;"><img v-img-url="scope.row.goods.image[0].file_path" alt=""/></div>
                                <div class="info">
                                    <div class="name">{{ scope.row.goods.goods_name }}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格">
                        <template slot-scope="scope">
                            <span v-if="scope.row.goods.spec_type == 10">单规格</span>
                            <span v-if="scope.row.goods.spec_type == 20">多规格</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="积分">
                        <template slot-scope="scope">
                            {{ scope.row.sku[0].point_num }}
                        </template>
                    </el-table-column>
                    <el-table-column label="金额">
                        <template slot-scope="scope">
                            <span class="orange fb">{{ scope.row.sku[0].point_money }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="limit_num" label="限购数量"></el-table-column>
                    <el-table-column prop="stock" label="活动库存"></el-table-column>
                    <el-table-column prop="sort" label="排序"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0" class="green">待审核</span>
                            <span v-if="scope.row.status == 10" class="green">通过</span>
                            <span v-if="scope.row.status == 20" class="gray">未通过</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="90">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status != 10" type="text" size="small" @click="edit(scope.row)">修改</el-button>
                            <el-button type="text" size="small" @click="delClick(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
            </div>
        </div>

        <!--商品选择-->
        <Goods :isgoods="isgoods" :exclude-ids="exclude_ids" :islist="false" @closeDialog="closeGoodsFunc"></Goods>
    </div>
</template>
<script>
    import PointsApi from "@/api/points";
    import Goods from "@/components/goods/Goods.vue";
    export default {
        components: {
            /*选择商品*/
            Goods
        },
        data() {
            return {
                formInline: {},
                form: {},
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*是否加载完成*/
                loading: true,
                /*是否打开选择商品*/
                isgoods: false,
                /*已有的id*/
                exclude_ids: [],
                /*已有的id*/
                activeName: "has_audit"
            };
        },
        created() {
            /*获取列表*/
            this.getData();
        },
        methods: {
            /*获取列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                Params.status = self.activeName;
                PointsApi.myList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        self.exclude_ids = data.data.exclude_ids;
                    })
                    .catch((error) => {});
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getData();
            },
            /*打开添加*/
            openGoods() {
                this.isgoods = true;
            },
            /*切换菜单*/
            handleClick(tab, event) {
                let self = this;
                self.curPage = 1;
                self.getData();
            },
            /*关闭商品选择*/
            closeGoodsFunc(e) {
                this.isgoods = false;
                if (e.type == "success") {
                    this.$router.push("/activity/point/add?goods_id=" + e.params.goods_id);
                }
            },
            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },
            edit(row) {
                this.$router.push("/activity/point/edit?point_goods_id=" + row.point_goods_id);
            },
            /*删除*/
            delClick: function(row) {
                let self = this;
                self.$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    PointsApi.delGoods({
                        point_goods_id: row.point_goods_id
                    }).then((data) => {
                        self.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        self.getData();
                    });
                });
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/activity/point/my.vue